module.exports = __webpack_public_path__ + "img/vivo.43cfe012.png";